module.exports = __webpack_public_path__ + "img/ic_list_info_chat.c35f0ff0.svg";